import { render } from "./NotFound.vue?vue&type=template&id=794489b9"
const script = {}
script.render = render

export default script